"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductPerformanceReportSchema = exports.ProductPerformanceCategoryRowSchema = exports.ProductPerformanceRowSchema = void 0;
const zod_1 = require("zod");
exports.ProductPerformanceRowSchema = zod_1.z.object({
    productId: zod_1.z.string(),
    variantId: zod_1.z.string().optional(),
    name: zod_1.z.string(),
    sku: zod_1.z.string().optional(),
    categoryId: zod_1.z.string().optional(),
    categoryName: zod_1.z.string().optional(),
    imageUrl: zod_1.z.string().optional(),
    unitsSold: zod_1.z.number(),
    revenue: zod_1.z.number(),
    cost: zod_1.z.number(),
    grossProfit: zod_1.z.number(),
    marginPct: zod_1.z.number(),
    avgSellPrice: zod_1.z.number(),
    transactions: zod_1.z.number(),
    rank: zod_1.z.number().optional(),
    growthPct: zod_1.z.number().optional(),
    currentStock: zod_1.z.number().optional(),
    daysOfStockRemaining: zod_1.z.number().optional(),
});
exports.ProductPerformanceCategoryRowSchema = zod_1.z.object({
    categoryId: zod_1.z.string(),
    categoryName: zod_1.z.string(),
    unitsSold: zod_1.z.number(),
    revenue: zod_1.z.number(),
    marginPct: zod_1.z.number(),
});
exports.ProductPerformanceReportSchema = zod_1.z.object({
    tenantId: zod_1.z.string(),
    locationId: zod_1.z.string(),
    from: zod_1.z.string(),
    to: zod_1.z.string(),
    totals: zod_1.z.object({
        totalUnits: zod_1.z.number(),
        totalRevenue: zod_1.z.number(),
        totalCost: zod_1.z.number(),
        totalProfit: zod_1.z.number(),
        avgMarginPct: zod_1.z.number(),
        uniqueProducts: zod_1.z.number(),
        productsWithZeroSales: zod_1.z.number(),
    }),
    bestSellers: zod_1.z.array(exports.ProductPerformanceRowSchema),
    slowMovers: zod_1.z.array(exports.ProductPerformanceRowSchema),
    stockouts: zod_1.z.array(exports.ProductPerformanceRowSchema),
    byCategory: zod_1.z.array(exports.ProductPerformanceCategoryRowSchema),
});
//# sourceMappingURL=product-performance.schema.js.map